import { Card, Group, List, Progress, RingProgress, SimpleGrid, Stack, Text, Title } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import ConfigBanner from '../../components/shared/ConfigBanner'
import Money from '../../components/shared/Money'
import PageHeader from '../../components/shared/PageHeader'
import Stat from '../../components/shared/Stat'
import { useResource } from '../../hooks'
import Message from '../../i18n/Message'
import { keys, loadAdminDashboard } from '../../store/dataActionCreators'

export default function AdminDashboard() {
  const { data } = useResource(keys.adminDashboard, loadAdminDashboard)
  const navigate = useNavigate()
  if (!data) return <PageHeader title="admin_dashboard_title" />
  const p = data.portfolio
  const by = data.applicationsByStatus || {}
  const maxAging = Math.max(1, ...data.aging.map((b) => b.amountKobo))
  const setup = data.setup
  return (
    <>
      <PageHeader title="admin_dashboard_title" />
      <ConfigBanner />
      {setup.productsActive === 0 && (
        <Card mb="lg">
          <Title order={5} mb="xs"><Message id="setup_checklist" /></Title>
          <List size="sm">
            <List.Item><Message id="setup_products" /></List.Item>
          </List>
        </Card>
      )}
      <SimpleGrid cols={{ base: 2, md: 4 }} mb="lg">
        <Stat label="fin_disbursed" kobo={p.disbursedKobo} />
        <Stat label="fin_collected" kobo={p.collectedKobo} />
        <Stat label="fin_outstanding" kobo={p.outstandingKobo} />
        <Stat label="fin_overdue" kobo={p.overdueKobo} onClick={() => navigate('/admin/overdue')} />
      </SimpleGrid>
      <SimpleGrid cols={{ base: 1, md: 3 }} mb="lg">
        <Card>
          <Title order={5} mb="sm"><Message id="queue_title" /></Title>
          <Stack gap={6}>
            <Group justify="space-between" onClick={() => navigate('/admin/applications')} style={{ cursor: 'pointer' }}>
              <Text size="sm"><Message id="status_submitted" /></Text><Text className="num" fw={600}>{by.submitted || 0}</Text>
            </Group>
            <Group justify="space-between"><Text size="sm"><Message id="status_in_review" /></Text><Text className="num" fw={600}>{by.in_review || 0}</Text></Group>
            <Group justify="space-between"><Text size="sm"><Message id="status_corrections_requested" /></Text><Text className="num" fw={600}>{by.corrections_requested || 0}</Text></Group>
            <Group justify="space-between" onClick={() => navigate('/admin/payments')} style={{ cursor: 'pointer' }}>
              <Text size="sm"><Message id="stat_pending_payments" /></Text><Text className="num" fw={600}>{data.pendingPayments}</Text>
            </Group>
          </Stack>
        </Card>
        <Card>
          <Title order={5} mb="sm"><Message id="aging_title" /></Title>
          <Stack gap="xs">
            {data.aging.map((b) => (
              <div key={b.label}>
                <Group justify="space-between">
                  <Text size="sm"><Message id="aging_bucket" values={{ label: b.label }} /> · {b.count}</Text>
                  <Money kobo={b.amountKobo} size="sm" />
                </Group>
                <Progress value={(b.amountKobo / maxAging) * 100} color="red" />
              </div>
            ))}
          </Stack>
        </Card>
        <Card>
          <Title order={5} mb="sm"><Message id="collection_rate" /></Title>
          <Group>
            <RingProgress size={110} thickness={12} sections={[{ value: p.collectionRate || 0, color: 'brand' }]}
              label={<Text ta="center" fw={600} className="num">{p.collectionRate === null ? '—' : `${p.collectionRate}%`}</Text>} />
            <Stack gap={2}>
              <Text size="sm" c="dimmed"><Message id="par1" /></Text><Money kobo={p.par1Kobo} />
              <Text size="sm" c="dimmed"><Message id="par30" /></Text><Money kobo={p.par30Kobo} />
            </Stack>
          </Group>
        </Card>
      </SimpleGrid>
    </>
  )
}
